import freedomLogo from "../assets/img/logo/freedom/logo.svg";
import demoLogo from "../assets/img/demo-logo.svg";
import healthSunLogo from "../assets/img/logo/healthsun/logo.svg";
import optimumLogo from "../assets/img/logo/Optimum/logo.svg";
import communicareLogo from "../assets/img/communicare-logo.svg";
import securLogo from "../assets/img/secure-logo.svg";
import ultimateLogo from "../assets/img/ultimate-logo.svg";
import prominenceLogo from "../assets/img/logo/Prominence/logo.svg";
import cmsLogo from "../assets/img/logo/CMS/logo.svg";
import cshLogo from "../assets/img/logo/CSH/logo.svg";
import gkLogo from "../assets/img/logo/GK/logo.svg";
import libertyLogo from "../assets/img/logo/Liberty/logo.svg";
import solisLogo from "../assets/img/logo/solis/solis_logo.svg";
import amsoLogo from "../assets/img/logo/amso/ahamso_logo.svg";
import aacoLogo from "../assets/img/logo/aaco/aaco-logo.svg";

const clientLogos = {
  freedom: freedomLogo,
  healthsun: healthSunLogo,
  optimum: optimumLogo,
  demo: demoLogo,
  communicare: communicareLogo,
  secur: securLogo,
  ultimate: ultimateLogo,
  prominence: prominenceLogo,
  cms: cmsLogo,
  csh: cshLogo,
  gk: gkLogo,
  liberty: libertyLogo,
  solis: solisLogo,
  ahaaco: aacoLogo,
  ahamso: amsoLogo,
};

export const getClientName = () => process.env.REACT_APP_ClientName || "";

export const getClientLogo = (clientName = getClientName()) =>
  clientLogos[clientName] || "";

export const getClientWelcomeName = () =>
  process.env.REACT_APP_Welcome_To || "AaNeelCare";
